// import styled from "styled-components";

// interface IProps {
//   gutterBottom?: boolean
// }

// const SubPageBanner = styled.div<IProps>`
//   font-size: 20px;
//   text-align: left;
//   font-weight: bold;
//   padding-top: 15px;
//   padding-left: 10px;
//   margin-bottom: ${({ gutterBottom }) => (gutterBottom ? 20 : 0)}px;
// `;

// export default SubPageBanner;

export default {};